// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2XGnu","rootSuccess":"CompleteLink_rootSuccess__1NgYx","rootFailure":"CompleteLink_rootFailure__1iNYl","isDisabled":"CompleteLink_isDisabled__1IN7V"};